import { colorBrands } from '../colors/colors.brands';

export const spinnerSemantics = {
  'icon-primary': {
    light: colorBrands['primary-500'],
    dark: colorBrands['primary-500'],
  },
  'icon-secondary': {
    light: colorBrands['neutral-1000'],
    dark: colorBrands['neutral-100'],
  },
};
